import React from "react";
import "./Wheel_Cash_Out_History.css";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import No_data from "../Common/No_data/No_data";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";

function Wheel_Cash_Out_History() {
  return (
    <>
      <section className="Wheel_Cash_Out_History">
        <Common_white_header headingText={"Wheel Cash Out History"} />
        <div className="container">
          <Filter_Drop />

          <No_data />
        </div>
      </section>
    </>
  );
}

export default Wheel_Cash_Out_History;
